import React, { Component } from 'react';
import StyleKit from './StyleKit';

class ProgressDonut extends Component {
    componentDidMount() {
        this.configureCanvas(this.props);
    }

    configureCanvas = props => {
        if (this.refs.canvas) {
            const canvas = this.refs.canvas;
            canvas.width = props.size;
            canvas.height = props.size;

            const frame = StyleKit.makeRect(0, 0, canvas.width, canvas.height);

            // Canvas, Primary Color, Text Color, Progress, Rect
            StyleKit.drawDonut(
                canvas,
                props.primaryColor,
                props.textColor,
                props.progress,
                frame
            );
        }
    };

    render = () => {
        this.configureCanvas(this.props);

        return <canvas ref="canvas" />;
    };
}

ProgressDonut.defaultProps = {
    size: 48,
    progress: 0.0,
    primaryColor: '#9ce73d',
    textColor: '#999999'
};

export default ProgressDonut;



// WEBPACK FOOTER //
// ./src/lib/ProgressDonut.js